import styled from '@emotion/styled'
import { colors } from 'utils/colors'
import { pxToRem, BREAKPOINTS } from 'utils/styled'

export const SWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0 ${pxToRem(130)}rem;
  margin-bottom: ${pxToRem(50)}rem;

  @media ${BREAKPOINTS.LG.max} {
    grid-gap: 2rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    grid-gap: 5rem;
  }
`

export const SList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`
export const SListItem = styled.li<{ color?: string }>`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.625rem;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    margin-top: 0.3125rem;
    margin-right: 0.625rem;
    flex-shrink: 0;
    vertical-align: middle;
  }

  p {
    color: ${(props) => props?.color ?? colors.gray[500]};
  }
`
